import 'node_modules/bootstrap/dist/js/bootstrap.bundle.js';
// import 'node_modules/cssuseragent/cssua.js';
import Headroom from '../node_modules/headroom.js/dist/headroom.js';
import '../node_modules/headroom.js/dist/jQuery.headroom.js';
import '../node_modules/jquery-inview/jquery.inview.js';
import anime from '../node_modules/animejs/lib/anime.es.js';
import Rellax from '../node_modules/rellax/rellax.js';
import Splide from '../node_modules/@splidejs/splide/dist/js/splide.min.js';
import { AutoScroll } from '../node_modules/@splidejs/splide-extension-auto-scroll/dist/js/splide-extension-auto-scroll.min.js';
import '../node_modules/@lottiefiles/lottie-player';
import '../node_modules/jquery-match-height/jquery.matchHeight';
import 'pivot-base.js';

window.Headroom = Headroom;
window.Splide = Splide;

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
};

jQuery(document).ready(function($) {

  // Hamburgers
  var $hamburger = $('.hamburger');
  $hamburger.on('click', function() {
    $hamburger.toggleClass('is-active');
  });

  // Headroom settings
  $(".pd-main-menu-wrap").headroom({
    offset: $(".pd-main-menu-wrap").outerHeight()
  });

  // Smooth scrolling using anime.js
  $('a.nav-link[href*="#"]:not([href="#"]),a.pd-main-nav-logo[href*="#"]:not([href="#"]),.pd-button-link a[href*="#"]:not([href="#"]),.pd-footer a[href*="#"]:not([href="#"])').on('click', function() {
    if (
      location.pathname.replace(/^\//, "") ==
      this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ?
        target :
        $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        anime({
          targets: 'html, body',
          scrollTop: target.offset().top,
          duration: 1000,
          easing: 'easeInOutExpo'
        });
        return false;
      }
    }

    $(".navbar-collapse").collapse("hide");
    $hamburger.removeClass('is-active');
  });

  // Navbar Toggles
  function toggleNavbarMethod() {
    // if ($(window).width() > 992) {
      $('.dropdown')
      .mouseover(function() {
        $(this).addClass('show').attr('aria-expanded','true');
        $(this).find('.dropdown-menu').addClass('show');
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
        // $('.navbar .dropdown > a').click(function() {
        //   location.href = this.href;
        // });
        $('.dropdown > a').click(function() {
          location.href = this.href;
        });
      })
      .mouseout(function() {
        $(this).removeClass('show').attr('aria-expanded','false');
        $(this).find('.dropdown-menu').removeClass('show');
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
      });
    // }
    // else {
    //   $('.navbar .dropdown').off('mouseover').off('mouseout');
    //   $('.navbar .dropdown > a > div').click(function() {
    //     $('.pd-toggle-icon').toggleClass('dropdown-open');
    //   });
    // }
    //
    if ($(window).width() < 992) {
      $( ".dropdown" ).prepend( "<div class='pd-toggle-icon'><img src='/wp-content/themes/wema-hoover-theme/images/caret-white.svg'></div>" );
    }
  }

  // Closes responsive menu when a scroll trigger link is clicked
  $(".nav-link").on('click', function() {
    $(".navbar-collapse").collapse("hide");
    $hamburger.toggleClass('is-active');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: ".collapse.navbar-collapse",
    offset: 0,
  })

  // Match padding
  function matchPadding() {
    $("body").css({"padding-top": $(".pd-main-menu-wrap").outerHeight() });
    $("#pd-main").css({"min-height": $("#pd-main").outerHeight() - $(".pd-main-menu-wrap").outerHeight() });
    $("html,body").css({"scroll-padding-top": $(".pd-main-menu-wrap").outerHeight() });
  }

  // inView jQuery
  $('.pd-card-wrapper,.animate__animated,.animate__paragraph p,.pd-border-left h4,.pd-section .col-lg-4,.pd-logo-section figure,.pd-speaking-cols div').on('inview', function(event, isInView) {
    $(this).addClass('animate__fadeInUp');
  });

  // Animate media listings on individual pages
  function animateCards() {
    $('.pd-media-listing').addClass('animate__fadeInUp');
    // $('.pd-listing').matchHeight();
  }
  $(document).on('facetwp-loaded', function() {
    if (FWP.loaded) {
      $('html, body').animate({
          scrollTop: 350
      }, 500);
      animateCards();
    }
  });
  animateCards();

  // inView Lottie
  let pdLottie = $('.pd-lottle-wrapper').attr('pd-lottie');
    $('.pd-lottle-wrapper').one('inview', function(event, isInView) {
        $(this).html('<lottie-player class="pd-lottie img-fluid" src="' + pdLottie + '" background="transparent" speed="1" autoplay></lottie-player>');
    });

  // jQuery matchHeight
  $('.pd-match-heading').matchHeight();
  $('.wp-block-feature-cards .card').matchHeight();
  // $('.pd-match-media-cards p').matchHeight({byRow: false});

  // Wrap button
  $('.pd-btn-outline-primary a, .pd-nav-btn a').each(function() {
    $(this).wrapInner("<span></span>");
  });

  // Add hidden nav trigger
  $('#pd-nav-trigger').hover(
    function () {
      $('.pd-main-menu-wrap').removeClass('headroom--unpinned').addClass('headroom--pinned');
    }
  );

  // Link to open modals
  function openModalOnHash() {
    if(window.location.hash && $("body").hasClass("blog")) {
      var hash = window.location.hash.substring(1);
      $('#'+hash).modal('show');
    }
  }
  openModalOnHash();

  // Add custom video thumbnails
  $(function() {
    var videos  = $(".embed-container");
    videos.on("click", function(){
      var elm = $(this),
          conts   = elm.contents(),
          le      = conts.length,
          ifr     = null;

      for(var i = 0; i<le; i++){
        if(conts[i].nodeType == 8) ifr = conts[i].textContent;
      }

      elm.addClass("player-show").html(ifr);
      elm.off("click");
    });
  });

  // Check if both elements are present
  function initializeSplide() {
    if ($('.wp-block-logo-slider').length && $('.wp-block-testimonial-slider').length) {
      // Initialize the first Splide instance
      const logoSlider = new Splide('.wp-block-logo-slider', {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        perPage: 1,
        autoWidth: true,
        pagination: false,
        arrows: false,
        autoScroll: {
          pauseOnHover: false,
          speed: 1
        }
      });
      logoSlider.mount(window.splide.Extensions);

      // Initialize the second Splide instance
      const testimonialSlider = new Splide('.wp-block-testimonial-slider', {
        type: 'loop',
        focus: 'center',
        perPage: 3,
        autoWidth: true,
        pagination: false,
        arrows: true,
      }).mount();
    }
  }

  // Array to store Rellax instances
  var rellaxInstances = [];

  // Rellax settings
  function rellaxItems() {
    rellaxInstances.forEach(instance => instance.destroy()); // Destroy existing instances
    rellaxInstances = []; // Reset the array
    console.log("Initializing Rellax");

    if ($(window).width() > 992) {
      const rellaxConfig = [
        { selector: '.home .display-1', options: { speed: 8, center: false } },
        { selector: '.pd-header-img img', options: { speed: 10, center: false } },
        { selector: '.pd-quote-wrapper', options: { speed: 8, center: true } },
        { selector: '.pd-eyes img', options: { speed: 6, center: true } },
        { selector: '.pd-speak-heading', options: { speed: 4, center: true } },
        { selector: '.pd-build-1 img', options: { speed: 8, center: true } },
        { selector: '.pd-build-2 img', options: { speed: 10, center: true } },
        { selector: '.wp-block-media-cards', options: { speed: 10, center: true } },
        { selector: '.pd-defined img', options: { speed: 10, center: true } },
        { selector: '.pd-orgs img', options: { speed: 6, center: true } }
      ];

      rellaxConfig.forEach(({ selector, options }) => {
        if ($(selector).length) {
          var instance = new Rellax(selector, options);
          rellaxInstances.push(instance);
        }
      });
    }
  }

  // Function to refresh all Rellax instances
  function refreshRellax() {
    rellaxInstances.forEach(instance => instance.refresh());
    console.log("Refreshing Rellax");
  }

  // Function to destroy all Rellax instances
  function destroyRellax() {
    rellaxInstances.forEach(instance => instance.destroy());
    rellaxInstances = [];
    console.log("Destroying Rellax");
  }

  // Let's debounce our heavy lifts // https://css-tricks.com/snippets/jquery/done-resizing-event/
  var resizeTimer;
  matchPadding();
  // rellaxItems();
  toggleNavbarMethod();
  initializeSplide();

  window.addEventListener('resize', debounce(() => {
    // Run code here, resizing has "stopped"
    matchPadding();
    // rellaxItems();
    toggleNavbarMethod();
    // location.reload();
  }, 250));

  // Feature detection for touch devices
  function isTouchDevice() {
    return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
  }

  // Usage of refresh and destroy
  if (!isTouchDevice()) {
    rellaxItems();
  } else {
    $("html").addClass('is-mobile');
    $("body").addClass('is-mobile');
  }

  $(window).on('load', function() {
    refreshRellax();
  });

  window.addEventListener('resize', debounce(() => {
    if (!isTouchDevice()) {
      location.reload();
      refreshRellax();
    }
  }, 250));
});